// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IMI9","questions":"styles_questions__1WgJO","footer":"styles_footer__3ZHqY"};